<template>
  <div class="main_holder sep-ai">
    <div class="content_holder">
      <div class="content">
        <h2>SEP AI analitik</h2>
        <p class="subtitle">Prototip: test Azure Search z iskalnikom, filtri, razvrščanje, faceti in analitikom.<br>
          Najprej poišči dokumente preko ključnih besed ali pomena (levo), nato preveri rezultate (spodaj), nazadnje se
          ti rezultati lahko analizirajo z pomočjo LLM (desno).</p>

        <div class="two_col_layout">
          <div class="col_left" ref="searchFormCol">
            <EvalvationAISearchForm />
          </div>

          <div class="col_right" ref="analyzeColRight" :style="analyzeColStyle">
            <EvalvationAIAnalyze v-model:model="analyzeModel" />
          </div>
        </div>

        <EvalvationAIResults :filter-options="filterOptions" :analyze-model="analyzeModel" />
      </div>
    </div>
  </div>
</template>

<script>
import EvalvationAISearchForm from './EvalvationAISearchForm.vue';
import EvalvationAIAnalyze from './EvalvationAIAnalyze.vue';
import EvalvationAIResults from './EvalvationAIResults.vue';

export default {
  components: { EvalvationAISearchForm, EvalvationAIAnalyze, EvalvationAIResults },
  data() {
    return {
      analyzeSectionMaxHeightPx: null,
      analyzeModel: 'gpt-5-nano',
    };
  },
  computed: {
    analyzeColStyle() {
      if (this.analyzeSectionMaxHeightPx == null) return {};
      return { maxHeight: this.analyzeSectionMaxHeightPx + 'px' };
    },
    filterOptions() {
      return this.$store.getters.evalvation_filter_options;
    },
  },
  methods: {
    _scheduleAnalyzeSectionHeightSync() {
      if (this._analyzeHeightRaf != null) return;
      this._analyzeHeightRaf = requestAnimationFrame(() => {
        this._analyzeHeightRaf = null;
        const left = this.$refs.searchFormCol;
        if (!left) return;
        const h = left.offsetHeight;
        if (h > 0 && h !== this.analyzeSectionMaxHeightPx) {
          this.analyzeSectionMaxHeightPx = h;
        }
      });
    },
  },
  mounted() {
    this.$nextTick(() => this._scheduleAnalyzeSectionHeightSync());
    const left = this.$refs.searchFormCol;
    if (left && typeof ResizeObserver !== 'undefined') {
      this._searchFormResizeObserver = new ResizeObserver(() => this._scheduleAnalyzeSectionHeightSync());
      this._searchFormResizeObserver.observe(left);
    }
  },
  beforeDestroy() {
    if (this._analyzeHeightRaf != null) {
      cancelAnimationFrame(this._analyzeHeightRaf);
      this._analyzeHeightRaf = null;
    }
    if (this._searchFormResizeObserver && this.$refs.searchFormCol) {
      this._searchFormResizeObserver.disconnect();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
